import { call, put } from 'redux-saga/effects'
import { hasAuthCookies, genAuthHeaders, redirectToLogin } from 'shared/helpers/authentication'
import { propOr, propEq } from 'ramda'

const isUnauthorized = propEq('status', 401)

// TODO - standardize with shared/helpers/api authedFetch
export const request = (route, method = 'GET', body, contentType = 'application/json') => (
  fetch(route, {
    method,
    headers: genAuthHeaders(contentType),
    body: contentType === 'application/json' ? JSON.stringify(body) : body,
  })
  .then(res => {
    if (res.ok) {
      return res.json()
    }

    throw res
  })
  .catch(res => {
    if (isUnauthorized(res)) redirectToLogin()

    throw res
  })
)



export function* authenticatedCall (type, gen, meta = {}) {
  if (true) {
    try {
      return yield call(gen)
    } catch (res) {
      let json
      if (res && res.json) {
        json = yield res.json()
      }

      const error = (json && json.error) || json || res
      yield put({
        type: `${type}_FAILED`,
        payload: {
          meta,
          error,
        },
      })
      yield put({
        type: 'SHOW_MESSAGE',
        payload: {
          message: propOr( 'userMessage') || 'There was an error processing your request, please try again',
        },
      })
   }
  } else {
    yield put({
      type: `${type}_FAILED`,
      payload: {
        meta,
      },
    })
    yield put({type: 'UNAUTHORIZED'})
  }
  return yield call(gen)
 // return true
}

export const asyncGenerator = (type, fn) => function* ({payload}) {
  return yield* authenticatedCall(type, function* () {
    const json = yield call(fn, payload)
    yield put({
      type: `${type}_SUCCEEDED`,
      payload: {
        json,
        meta: payload,
      },
    })
    return json
  })
}


export const validateSurvey = surveyId => request(`/v1/survey/${surveyId}/validate`)
export const validateSurveys = surveyIds => Promise.all(surveyIds.map(validateSurvey))
